import React from 'react'

import { Checkbox, FormControlLabel } from '@material-ui/core'
import cn from 'classnames'
import { get, includes, without } from 'lodash'
import PropTypes from 'prop-types'

import './CheckList.scss'

const toggleValue = (selectedValues, value) =>
  includes(selectedValues, value) ? without(selectedValues, value).sort() : [...selectedValues, value].sort()

const CheckListSelector = ({ selectedValues, values, labels, required, onChange }) => {
  const hasAnySelected = selectedValues.length > 0
  const checkedOptions = {}
  selectedValues.forEach((y) => (checkedOptions[y] = true))
  return (
    <div className="check-list-comp">
      {labels.map((label, idx) => {
        const checked = get(checkedOptions, values[idx], false)
        return (
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                checked={checked}
                onChange={() => onChange(toggleValue(selectedValues, values[idx]))}
                color="primary"
              />
            }
          />
        )
      })}
      {required && hasAnySelected === false && (
        <p className={cn({ 'has-none-selected': hasAnySelected === false })}>At least one selection is required.</p>
      )}
    </div>
  )
}

CheckListSelector.propTypes = {
  required: PropTypes.bool.isRequired,
  selectedValues: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

CheckListSelector.defaultProps = {
  required: false,
  selectedValues: [],
  values: [],
  labels: [],
}

export default CheckListSelector
